

import React, { useEffect, useState } from "react";
import {
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
} from "react-router-dom";
import axios from "axios";

// UI Components
import Homepage from "./uiComponents/Homepage";
import Landing from "./uiComponents/Landing";
import userLogin from "./uiComponents/Login";
import Mywallet from "./uiComponents/Mywallet";
import Addcase from "./uiComponents/Addcase";
import Pay from "./uiComponents/Pay";
import Withdrawopt from "./uiComponents/Withdrawopt";
import Profile1 from "./uiComponents/Profile1";
import ViewGame1 from "./uiComponents/ViewGame1";
import Gamehistory from "./uiComponents/Gamehistory";
import Transactionhistory from "./uiComponents/Transactionhistory";
import Referralhis from "./uiComponents/Referralhis";
import Refer from "./uiComponents/Refer";
import Notification from "./uiComponents/Notification";
import Support from "./uiComponents/Support";
import Kyc2 from "./uiComponents/Kyc2";
import RefundPolicy from "./uiComponents/RefundPolicy";
import terms_condition from "./uiComponents/terms_condition";
import PrivacyPolicy from "./uiComponents/PrivacyPolicy";
import Gamerules from "./uiComponents/Gamerules";
import ResponsibleGaming from "./uiComponents/ResponsibleGaming";
import Return from "./uiComponents/Return";
import Notify from "./uiComponents/Notify";
import Redeem from "./uiComponents/Redeem";
import AboutUs from "./uiComponents/AboutUs";
import Invoice from "./uiComponents/Invoice";
import Maintenence from "./uiComponents/Maintenence";
import GameLoader from "./uiComponents/GameLoader";
import GameLoader1 from "./uiComponents/GameLoader1";
import BetCard from "./uiComponents/BetCard";
import LudoRich from "./uiComponents/LudoRich";
import Chat from "./uiComponents/Chat";

// Components
import Header from "./Components/Header";
import Rightcontainer from "./Components/Rightcontainer";
import Footer from "./Components/Footer";
import socket from "./Components/socket";

// Firebase & Notifications
import { onMessageListener } from "../services/firebase";
import { ToastContainer, toast } from "react-toastify";

// UI Libraries
import "react-toastify/dist/ReactToastify.css";
import { Widget, addResponseMessage, addUserMessage, setQuickButtons } from "react-chat-widget";
import "react-chat-widget/lib/styles.css";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import "../assets/newbase.css";
import "../assets/responsive.css";

const App2 = () => {
  const history = useHistory();
  const { pathname } = useLocation();

  const [user, setUser] = useState();
  const [accessToken, setAccessToken] = useState(localStorage.getItem("token"));
  const [settinData, setSettingData] = useState(undefined);
  const [notification, setNotification] = useState("");
  const [show, setShow] = useState(false);
  const [UserData, setUserData] = useState([]);
  const [state, setState] = useState({ right: false });

  // Drawer toggle
  const toggleDrawer = (anchor, open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) return;
    setState({ ...state, [anchor]: open });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Fetch user data
  const getUser = () => {
    if (!accessToken) return;
    axios
      .get("https://api.rrludo.in/me", { headers: { Authorization: `Bearer ${accessToken}` } })
      .then((res) => setUser(res.data))
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          setAccessToken(null);
        }
      });
  };

  useEffect(() => {
    getUser();
  }, []);

  // Socket listeners
  useEffect(() => {
    socket.on("websettingGet", (data) => {
      localStorage.setItem("sitSetting", JSON.stringify(data));
      setSettingData(data);
    });

    socket.on("recive-msg", (msgs) => {
      if (msgs?.sender !== user?._id) addResponseMessage(msgs.text);
    });
  }, []);

  // Firebase notifications
  useEffect(() => {
    onMessageListener()
      .then((payload) => {
        setNotification({
          title: payload.notification.title,
          body: payload.notification.body,
        });
        toast.success(
          <div>
            <b>{payload.notification.title}</b>
            <br />
            {payload.notification.body}
          </div>,
          { position: "top-right", autoClose: 5000, hideProgressBar: true }
        );
      })
      .catch((err) => console.log("Notification error:", err));
  }, []);

  // User list drawer
  const UserList = () => {
    fetch("https://api.rrludo.in/chat/ticket-list", {
      method: "GET",
      headers: { Authorization: `Bearer ${accessToken}` },
    })
      .then((res) => res.json())
      .then(setUserData)
      .catch(console.log);
  };

  const list = (anchor) => (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(anchor, false)} onKeyDown={toggleDrawer(anchor, false)}>
      <List>
        {UserData.map((item, index) => (
          <ListItem key={index} disablePadding>
            <ListItemButton>
              <ListItemText primary={item?.createdAt} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  // Quick buttons for chat widget
  setQuickButtons([{ label: "Add Image", value: "" }]);

  const handleSendMessage = (msg) => {
    if (!msg) return;
    socket.emit("create-msg", { text: msg, sender: user?._id });
  };

  // Check maintenance mode
  const isMaintenance = settinData?.siteMaintenance === true || settinData?.siteMaintenance === "true";
  if (isMaintenance) return <Maintenence settinData={settinData}/>;



if (!accessToken) {
  return (
    <>
      {/* Header har page pe chahiye */}
       <div className="com_message_main">
          <span>COMMISSION 5% : REFERRAL 3% FOR ALL GAMES</span>
      </div>
      <Header />

      <Switch>
        <Route exact path="/" component={Landing} />
        <Route path="/login" component={userLogin} />
        <Redirect to="/login" />
      </Switch>

      {/* Footer bhi har page pe chahiye */}
      <Footer />
    </>
  );
}



  // Normal routes
  return (
    <>
    <div className="com_message_main">
          <span>COMMISSION 5% : REFERRAL 3% FOR ALL GAMES</span>
      </div>
      <div className="App" style={{ zIndex: 999, position: "absolute" }}>
        <Widget
          handleNewUserMessage={handleSendMessage}
          showFileUploader
          profileAvatar={settinData?.Logo ? `https://api.rrludo.in/${settinData.Logo}` : ""}
          title={
            <div>
              <div>
                {["right"].map((anchor) => (
                  <React.Fragment key={anchor}>
                    <Button onClick={UserList}>User List</Button>
                    <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
                      {list(anchor)}
                    </Drawer>
                  </React.Fragment>
                ))}
              </div>
              Khelo Hub
            </div>
          }
          subtitle="SUPPORT"
        />
      </div>
 
      <div className="leftContainer">
         
        <Header user={user} />
      </div>
     

      <Switch>
        <Route path="/betcard" component={BetCard} />
        <Route path="/transaction-history" component={Transactionhistory} />
        <Route exact path="/Referral-history" component={Referralhis} />
        <Route exact path="/landing" component={Landing} />
        <Route exact path="/Gamehistory" component={Gamehistory} />
        <Route path="/HomePage/:Game" render={() => <Homepage walletUpdate={getUser} setsocket={socket} />} />
        <Route path="/LudoRich/:Game" component={LudoRich} />
        <Route exact path="/refer" component={Refer} />
        <Route exact path="/Notification" component={Notification} />
        <Route exact path="/" component={Landing} />
        <Route path="/profile" component={Profile1} />
        <Route path="/viewgame1/:id" component={ViewGame1} />
        <Route path="/addcase" render={() => <Addcase walletUpdate={getUser} settinData={settinData} />} />
        <Route path="/Withdrawopt" render={() => <Withdrawopt walletUpdate={getUser} settinData={settinData} />} />
        <Route path="/wallet" component={Mywallet} />
        <Route path="/support" render={() => <Support handleShow={handleShow} />} />
        <Route path="/kyc2" render={() => <Kyc2 user={user} />} />
        <Route path="/Rules" component={Gamerules} />
        <Route path="/RefundPolicy" component={RefundPolicy} />
        <Route path="/PrivacyPolicy" component={PrivacyPolicy} />
        <Route path="/term-condition" component={terms_condition} />
        <Route path="/return" render={() => <Return walletUpdate={getUser} />} />
        <Route path="/notify" component={Notify} />
        <Route path="/Redeem" render={() => <Redeem walletUpdate={getUser} />} />
        <Route path="/contact-us" component={Support} />
        <Route path="/responsible-gaming" component={ResponsibleGaming} />
        <Route path="/about" component={AboutUs} />
        <Route path="/invoice" component={Invoice} />
        <Route path="/pay-status" component={Pay} />
        <Route path="/loader" component={GameLoader} />
        <Route path="/loader1" component={GameLoader1} />
        <Redirect to="/landing" />
      </Switch>

      <div className="rightContainer">
        <Rightcontainer />
      </div>

      <Footer user={user}/>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} theme="light" />

      <Modal show={show} onHide={handleClose} animation={false} centered>
        <Modal.Body className="p-0 m-0">
          <Chat />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default App2;

